import {
  BEGIN_CREATE_DSA_WORKFLOW,
  BEGIN_CLONE_DSA_WORKFLOW,
  BEGIN_CONVERT_DSA_WORKFLOW,
  CONFIRM_BEGIN_CONVERT_DSA_WORKFLOW,
  CANCEL_CREATE_DSA_WORKFLOW,
  PROMPT_FOR_NEW_DSA_LINKED_OPPORTUNITIES,
  CONFIRM_SALESFORCE_SYNC_ERROR,
  CONFIRM_BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW,
  BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW
} from '../constants/actionTypes';

import { FULL_DSA } from '../constants/dsaTypes';

export const beginCreateDSAWorkflow = (dsaType = FULL_DSA) => {
  return {
    type: BEGIN_CREATE_DSA_WORKFLOW,
    dsaType
  };
};

export const beginCloneDSAWorkflow = (dsa) => {
  return {
    type: BEGIN_CLONE_DSA_WORKFLOW,
    dsa
  };
};

export const beginConvertDSAWorkflow = (dsa) => {
  return {
    type: BEGIN_CONVERT_DSA_WORKFLOW,
    dsa
  };
};

export const confirmBeginConvertDSAWorkflow = () => {
  return {
    type: CONFIRM_BEGIN_CONVERT_DSA_WORKFLOW
  };
};

export const confirmBeginConvertCustomerDSAWorkflow = (dsa) => {
  return {
    type: CONFIRM_BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW,
    dsa
  };
};

export const beginConvertCustomerDSAWorkflow = (dsa) => {
  return {
    type: BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW,
    dsa
  };
};

export const cancelCreateDSAWorkflow = () => {
  return {
    type: CANCEL_CREATE_DSA_WORKFLOW
  };
};

export const promptForNewDSALinkedOpportunities = () => {
  return {
    type: PROMPT_FOR_NEW_DSA_LINKED_OPPORTUNITIES
  };
};

export const confirmSalesforceSyncError = () => {
  return {
    type: CONFIRM_SALESFORCE_SYNC_ERROR
  };
};



// WEBPACK FOOTER //
// ./src/actions/createDSAWorkflowActions.js